import { Injectable, inject } from '@angular/core';
import { DevicesPayload } from '../../../equipment/devices/components/devices.models';
import { Observable } from 'rxjs';
import { CreateUserRole, UserRolesResponse } from '../user-roles.types';
import { HttpClient, HttpContext, HttpStatusCode } from '@angular/common/http';
import { LOADER_CONTEXT } from '../../../../services/interceptors/loader.interceptor';

@Injectable({
  providedIn: 'root'
})
export class UserRolesApiService {
  private http = inject(HttpClient);

  private readonly API = `/api/user-roles`;

  getAll(tableState: DevicesPayload): Observable<UserRolesResponse> {
    return this.http.post<UserRolesResponse>(this.API, tableState, {
      context: new HttpContext().set(LOADER_CONTEXT, true)
    });
  }

  createUserRole(tableState: CreateUserRole): Observable<HttpStatusCode> {
    return this.http.post<HttpStatusCode>(`${this.API}/0`, tableState);
  }

  updateUserRole(tableState: CreateUserRole, roleId: number): Observable<HttpStatusCode> {
    return this.http.put<HttpStatusCode>(`${this.API}/${roleId}`, tableState);
  }

  deleteUserRole(roleId: number): Observable<HttpStatusCode> {
    return this.http.delete<HttpStatusCode>(`${this.API}/${roleId}`);
  }
}
